/**
 * StatusBadge — Badge com dot colorido + texto de status
 */
import { T } from '../../styles/tokens';

type StatusVariant = 'online' | 'offline' | 'warning' | 'error' | 'pending';

interface StatusBadgeProps {
  /** Variante de status */
  variant: StatusVariant;
  /** Texto exibido (opcional, usa nome da variante como padrão) */
  label?: string;
  /** Tamanho */
  size?: 'sm' | 'md';
}

const VARIANT_COLORS: Record<StatusVariant, string> = {
  online: T.success,
  offline: T.textMuted,
  warning: T.warning,
  error: T.danger,
  pending: T.purple,
};

const VARIANT_LABELS: Record<StatusVariant, string> = {
  online: 'Online',
  offline: 'Offline',
  warning: 'Atenção',
  error: 'Erro',
  pending: 'Pendente',
};

export function StatusBadge({ variant, label, size = 'md' }: StatusBadgeProps) {
  const color = VARIANT_COLORS[variant];
  const isSm = size === 'sm';
  const dotSize = isSm ? 6 : 8;

  return (
    <div style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: isSm ? T.space1 : T.space2,
    }}>
      <div style={{
        width: dotSize,
        height: dotSize,
        borderRadius: T.radiusFull,
        background: color,
        flexShrink: 0,
      }} />
      <span style={{
        fontSize: isSm ? T.textXs : T.textSm,
        color: T.textSecondary,
        fontWeight: T.weightMedium,
      }}>
        {label || VARIANT_LABELS[variant]}
      </span>
    </div>
  );
}
